import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import { useError } from '../contexts/ErrorContext';



// 🔥 Библиотека (типы питания, категории, оборудование) - кэш на всю сессию
export const useLibrary = () => {
  const { handleError } = useError(); // ✅ Берем handleError из контекста
  return useQuery({
    queryKey: ['library'], 
    queryFn: async () => {
      try {
        const rates = await api.getLibrary();
        return rates;
      } catch (error) {
        // Обрабатываем ошибку
        handleError(error, { operation: 'getLibrary' });
        throw error; // Важно: пробрасываем дальше
      }
    },
    staleTime: Infinity,      // Никогда не устаревает
    gcTime: Infinity,         // Никогда не удаляется из кэша
    refetchOnMount: false,    // Не обновлять при монтировании
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1, 
  });
};

// 🔥 Тарифы - кэш на всю сессию
export const useRates = () => {
   const { handleError } = useError(); // ✅ Берем handleError из контекста
  return useQuery({
    queryKey: ['rates'],
    queryFn: async () => {
      try {
        const rates = await api.getRates();
        return rates;
      } catch (error) {
        // Обрабатываем ошибку
        handleError(error, { operation: 'getRates' });
        throw error; // Важно: пробрасываем дальше
      }
    },
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1,
  });
};

// 🔥 Промокоды - кэш на всю сессию
export const usePromoCodes = () => { 
  const { handleError } = useError(); // 
  return useQuery({
    queryKey: ['promoCodes'],
    queryFn: async () => {
      try {
        const rates = await api.getPromoCodes();
        return rates;
      } catch (error) {
        console.log(error)
        // Обрабатываем ошибку
        handleError(error);
        throw error; // Важно: пробрасываем дальше
      }
    }, 
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: 1,
  });
};